import axios from 'axios';

const normalizeApiBase = (base) => (base || "").replace(/[?&]key$/, "");

const axiosConfig = {
    transformRequest: (data, headers) => {
        if (headers?.common) {
            delete headers.common['Authorization'];
            delete headers.common['Subdomain'];
        }
        return data;
    }
};

const buildGoogleApiUrl = (type, value) => {
    const googleAPIKey = `${process.env.REACT_APP_GOOGLE_KEY}`;
    const cx = `${process.env.REACT_APP_ENGINE_ID}`;
    const q = value || "";

    if (type === "youtube") {
        const params = new URLSearchParams({
            key: googleAPIKey,
            q,
            maxResults: "20",
            part: "snippet"
        });

        return `${normalizeApiBase(process.env.REACT_APP_YOUTUBE_API)}?${params.toString()}`;
    }

    if (type === "google.image" || type === "google.search") {
        const params = new URLSearchParams({
            key: googleAPIKey,
            cx,
            q,
            num: "10"
        });

        if (type === "google.image") {
            params.set("searchType", "image");
        }

        return `${normalizeApiBase(process.env.REACT_APP_SEARCH_API)}?${params.toString()}`;
    }

    return "";
};

const searchGoogleService = (type, value) =>
{
    const api = buildGoogleApiUrl(type, value);
    return axios.get(api, axiosConfig);
}

const searchGoogleServiceAsync = async (type, value) =>
{
    return await searchGoogleService(type, value);
}

export default {
    searchGoogleService,
    searchGoogleServiceAsync
  };
